import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'filterAll',
    'filterAllCount',
    'filterNeedsScript',
    'filterNeedsScriptCount',
    'filterReady',
    'filterReadyCount',
    'filterDone',
    'filterDoneCount',
    'filterFailed',
    'filterFailedCount',
    'filterNoScript',
    'filterNoScriptCount',
    'tableWrap',
    'tableBody',
    'emptyState'
  ];

  static values = {
    filter: { type: String, default: 'all' }
  };

  updateStats(event) {
    const { stats } = event.detail;
    if (!stats) return;

    if (this.hasFilterAllCountTarget) this.filterAllCountTarget.textContent = stats.total;
    if (this.hasFilterNeedsScriptCountTarget) {
      this.filterNeedsScriptCountTarget.textContent = stats.pending;
    }
    if (this.hasFilterReadyCountTarget) this.filterReadyCountTarget.textContent = stats.ready;
    if (this.hasFilterDoneCountTarget) this.filterDoneCountTarget.textContent = stats.captured;
    if (this.hasFilterFailedCountTarget) this.filterFailedCountTarget.textContent = stats.failed;
    if (this.hasFilterNoScriptCountTarget) {
      this.filterNoScriptCountTarget.textContent = stats.no_script;
    }
  }

  showEmptyState() {
    if (!this.hasTableBodyTarget) return;
    if (this.tableBodyTarget.querySelector('tr')) return;

    if (this.hasTableWrapTarget) this.tableWrapTarget.hidden = true;
    if (this.hasEmptyStateTarget) this.emptyStateTarget.hidden = false;
  }
}
